// extracted by mini-css-extract-plugin
module.exports = {"MegaMenu":"MegaMenu___2grlx","IsActive":"IsActive___18hP4","loading":"loading___3tTP0"};